// RenderAttachmentThumbnail.tsx
import * as React from 'react'
import RenderPdfThumbnail from './RenderPdfThumbnail'
import RenderThumbnail from './RenderThumbnail'

interface Attachment {
  id: string
  iconLink: string
  mimeType: string
  name: string
  thumbnailLink: string
  url: string
}

interface RenderAttachmentThumbnailProps {
  attachment: Attachment
  attachmentIndex: number
  onDeleteAttachment: (index: number) => void
  onOpenViewer: (index: number) => void
  getThumbnail: (attachment: Attachment) => React.ReactElement

  isNoteCreator: boolean
}

const RenderAttachmentThumbnail: React.FC<RenderAttachmentThumbnailProps> = ({
  attachment,
  attachmentIndex,
  onDeleteAttachment,
  onOpenViewer,
  getThumbnail,
  isNoteCreator,
}) => {
  const isPdf = attachment.mimeType === 'application/pdf' || attachment.name.toLowerCase().endsWith('.pdf')

  const Component = isPdf ? RenderPdfThumbnail : RenderThumbnail

  return (
    <Component
      attachment={attachment}
      attachmentIndex={attachmentIndex}
      onDeleteAttachment={onDeleteAttachment}
      onOpenViewer={onOpenViewer}
      getThumbnail={getThumbnail}
      isNoteCreator={isNoteCreator}
    />
  )
}

export default RenderAttachmentThumbnail
